import React, { useEffect, useRef, useState } from "react";
import JobProfileFirst from "../../components/JobSpecification/JobProfileFirst";
import {
  Box,
  Grid,
  Typography,
  useMediaQuery,
  IconButton,
  Button,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CampaignIcon from "@mui/icons-material/Campaign";
import OverviewIcon from "../../assets/images/JobIcon/Overview.svg";
import GoalIcon from "../../assets/images/JobIcon/goal.svg";
import CheckIcon from "../../assets/images/JobIcon/check-bold.svg";
import SymbolsIcon from "../../assets/images/JobIcon/symbols_step.svg";
import TeamsIcon from "../../assets/images/JobIcon/team-people.svg";
import JobProfileSecond from "../../components/JobSpecification/JobProfileSecond";
import JobProfileThird from "../../components/JobSpecification/JobProfileThird";
import JobProfilefourth from "../../components/JobSpecification/JobProfilefourth";
import JobProfilefifth from "../../components/JobSpecification/JobProfilefifth";
import JobProfileSixth from "../../components/JobSpecification/JobProfileSixth";
import { useParams, useNavigate } from "react-router-dom";
import { getRequest } from "../../api/apiServices";
import { getJob } from "../../api/apiList";
import Loading from "../../utils/Loading";

const JobSpecification: React.FC = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const isMobile = useMediaQuery("(max-width:635px)");
  const [loading, setLoading] = useState(false);
  const [update, setUpdate] = useState(false);
  const navigate = useNavigate();

  // To Handle the data
  const [formData, setFormData] = useState({});

  // Get The Id
  const params = useParams();

  const goToNextPage = () => {
    setCurrentPage(currentPage + 1);
  };

  const goToPreviousPage = () => {
    setCurrentPage(currentPage - 1);
  };

  const handleOverviewClick = () => {
    setCurrentPage(1);
  };

  const handleResponsibilitiesClick = () => {
    setCurrentPage(2);
  };

  const handleChallengesClick = () => {
    setCurrentPage(3);
  };

  const handleTeamCultureClick = () => {
    setCurrentPage(4);
  };

  const handleInterviewprocesClick = () => {
    setCurrentPage(5);
  };
  // Get The Job Data
  const getJobData = async () => {
    const response = await getRequest(getJob(params?.id));
    return response?.data?.data;
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (params?.id) {
          setLoading(true);
          const data = await getJobData();
          setFormData(data);
          setUpdate(true);
          setLoading(false);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [params?.id]);

  return loading ? (
    <Loading />
  ) : (
    <div>
      {/* Back Button */}
      <Box
        sx={{
          padding: { xs: 2, sm: 2, md: 3 },
          paddingBottom: 0,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 2,
        }}
      >
        <IconButton
          onClick={() => navigate(-1)}
          sx={{
            backgroundColor: "#ffffff",
            boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
            "&:hover": {
              backgroundColor: "#84E1CC",
              "& svg": { color: "#fff" },
            },
          }}
        >
          <ArrowBackIcon sx={{ color: "#84E1CC" }} />
        </IconButton>
        {params?.id && (
          <Button
            variant="contained"
            startIcon={<CampaignIcon />}
            onClick={() => navigate(`/campaigns/create/${params.id}`)}
            sx={{
              bgcolor: "#56c6a9",
              "&:hover": { bgcolor: "#45b598" },
            }}
          >
            Create Campaign
          </Button>
        )}
      </Box>

      <Grid
        container
        spacing={1}
        justifyContent={isMobile ? "center" : "center"}
      >
        {currentPage !== 6 && (
          <>
            <Grid xs={2} maxWidth={isMobile ? "none" : "auto"}>
              <Grid mt="33px"></Grid>
              <Grid
                className="box-shadow"
                direction="column"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                bgcolor="#FFFFFF"
                borderRadius="14px"
                border="1px solid #D9D9D9"
                onClick={handleOverviewClick}
                style={{ cursor: "pointer" }}
              >
                <Grid padding="28px 90px 0px 98px">
                  <Box padding="15px" borderRadius="7px" bgcolor="#84E1CC">
                    <img src={OverviewIcon} />
                  </Box>
                </Grid>
                <Grid padding="17px 35px 26px 35px">
                  <Typography fontSize="13px" fontWeight={500} color="#273848">
                    Overview &amp;
                    <br />
                    Job features
                  </Typography>
                </Grid>
              </Grid>
              <Grid mt="26px"></Grid>
              <Grid
                className="box-shadow"
                direction="column"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                bgcolor="#FFFFFF"
                borderRadius="14px"
                border="1px solid #D9D9D9"
                onClick={handleResponsibilitiesClick}
                style={{ cursor: "pointer" }}
              >
                <Grid padding="28px 90px 0px 98px">
                  <Box padding="15px" borderRadius="7px" bgcolor="#84E1CC">
                    <img src={CheckIcon} />
                  </Box>
                </Grid>
                <Grid padding="17px 35px 26px 35px">
                  <Typography
                    fontSize="13px"
                    lineHeight="15.79px"
                    fontWeight={500}
                    color="#273848"
                  >
                    Responsibilities &amp;
                    <br />
                    &nbsp;&nbsp;&nbsp;Qualifications
                  </Typography>
                </Grid>
              </Grid>
              <Grid mt="26px"></Grid>
              <Grid
                className="box-shadow"
                direction="column"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                bgcolor="#FFFFFF"
                borderRadius="14px"
                border="1px solid #D9D9D9"
                onClick={handleChallengesClick}
                style={{ cursor: "pointer" }}
              >
                <Grid padding="28px 90px 0px 98px">
                  <Box padding="15px" borderRadius="7px" bgcolor="#84E1CC">
                    <img src={GoalIcon} />
                  </Box>
                </Grid>
                <Grid padding="17px 35px 26px 35px">
                  <Typography fontSize="13px" fontWeight={500} color="#273848">
                    Challenges & Goals
                  </Typography>
                </Grid>
              </Grid>
              <Grid mt="26px"></Grid>
              <Grid
                className="box-shadow"
                direction="column"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                bgcolor="#FFFFFF"
                borderRadius="14px"
                border="1px solid #D9D9D9"
                onClick={handleTeamCultureClick}
                style={{ cursor: "pointer" }}
              >
                <Grid padding="28px 90px 0px 98px">
                  <Box padding="15px" borderRadius="7px" bgcolor="#84E1CC">
                    <img src={TeamsIcon} />
                  </Box>
                </Grid>
                <Grid padding="17px 35px 26px 35px">
                  <Typography fontSize="13px" fontWeight={500} color="#273848">
                    Team & Culture
                  </Typography>
                </Grid>
              </Grid>
              <Grid mt="26px"></Grid>
              <Grid
                className="box-shadow"
                direction="column"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                bgcolor="#FFFFFF"
                borderRadius="14px"
                border="1px solid #D9D9D9"
                style={{ cursor: "pointer" }}
                onClick={handleInterviewprocesClick}
              >
                <Grid padding="28px 90px 0px 98px">
                  <Box padding="15px" borderRadius="7px" bgcolor="#84E1CC">
                    <img src={SymbolsIcon} />
                  </Box>
                </Grid>
                <Grid padding="17px 35px 26px 35px">
                  <Typography fontSize="13px" fontWeight={500} color="#273848">
                    &nbsp;&nbsp;&nbsp;Interview process
                  </Typography>
                </Grid>
              </Grid>
              <Grid mt="26px"></Grid>
            </Grid>
          </>
        )}
        <Grid item xs={8} maxWidth={isMobile ? "100%" : "100%"}>
          {currentPage === 1 && (
            <JobProfileFirst
              onNext={goToNextPage}
              setFormData={setFormData}
              initialData={formData}
              mode={update}
            />
          )}
          {currentPage === 2 && (
            <JobProfileSecond
              onBack={goToPreviousPage}
              onNext={goToNextPage}
              setFormData={setFormData}
              initialData={formData}
              mode={update}
            />
          )}
          {currentPage === 3 && (
            <JobProfileThird
              onBack={goToPreviousPage}
              onNext={goToNextPage}
              setFormData={setFormData}
              initialData={formData}
              mode={update}
            />
          )}
          {currentPage === 4 && (
            <JobProfilefourth
              onBack={goToPreviousPage}
              onNext={goToNextPage}
              setFormData={setFormData}
              initialData={formData}
              mode={update}
            />
          )}
          {currentPage === 5 && (
            <JobProfilefifth
              onBack={goToPreviousPage}
              onNext={goToNextPage}
              setFormData={setFormData}
              initialData={formData}
              mode={update}
            />
          )}
          {currentPage === 6 && (
            <JobProfileSixth
              onBack={goToPreviousPage}
              onNext={goToNextPage}
              initialData={formData}
              mode={update}
            />
          )}
        </Grid>
      </Grid>
    </div>
  );
};

export default JobSpecification;
